'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pub = exports.sub = undefined;

var _event = require('../../event/event');

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EVENT = '/sally-fn/events/documents/listed'; // Event

var sub = exports.sub = function sub(fn) {
  return _event2.default.sub(EVENT, fn);
};

var pub = exports.pub = function pub() {
  for (var _len = arguments.length, documents = Array(_len), _key = 0; _key < _len; _key++) {
    documents[_key] = arguments[_key];
  }

  return _event2.default.pub(EVENT, documents);
};